import {inject, Injectable, SecurityContext} from '@angular/core';
import {addDoc, collection, doc, Firestore, getCountFromServer, getDoc, query, where} from 'firebase/firestore';
import {getFunctions, httpsCallable} from 'firebase/functions';
import {FirebaseInitService} from '../shared/firebase-init.service';
import {DomSanitizer} from '@angular/platform-browser';
import {SendEmailV3_1} from 'node-mailjet/declarations/types/api/SendEmail';
import {Profile, Setting} from '@models';
import {SettingsService} from '../community';

@Injectable()
export class SendmailService {

	private readonly firebaseInit = inject(FirebaseInitService);
	private sanitizer = inject(DomSanitizer);
	private settingsService = inject(SettingsService);

	private get functions() {
		return getFunctions(this.firebaseInit.app);
	}

	private get firestore(): Firestore {
		return this.firebaseInit.firestore;
	}

	public async sendFormToAdmin(user: Profile, message: string) {
		const document = await getDoc(doc(this.firestore, 'mailTemplates', 'FormContactSlaveous'));
		let bodyHtml = document.data()!['body'];
		bodyHtml = bodyHtml.replace('${user.email}', this.sanitizer.sanitize(SecurityContext.HTML, user.email));
		bodyHtml = bodyHtml.replace('${user.username}', this.sanitizer.sanitize(SecurityContext.HTML, user.username));
		bodyHtml = bodyHtml.replace('${message}', this.sanitizer.sanitize(SecurityContext.HTML, message));
		return await this.sendMail([{
			                           Email: 'devapp.slaveous@gmail.com',
			                           Name: 'Slaveous Team'
		                           }], [], [], 'Nouveau message depuis le formulaire de contact',
		                           bodyHtml,
		                           'FormContactSlaveous');
	}

	public sendNewMessageToUser(user: Profile) {
		const template = 'NewMessageToUser';
		this.settingsService.getSettings(user).then((settings: Setting): Promise<unknown> => {
			return this.sendMailManager(user, template, settings.currentLanguage.shortCode, settings);
		});
	}

	public sendNewFriendToUser(user: Profile) {
		const template = 'NewFriendToUser';
		this.settingsService.getSettings(user).then((settings: Setting): Promise<unknown> => {
			const langShortCode = settings.currentLanguage.shortCode;
			if (settings.sendMailForNewMessage) {
				return this.sendMailManager(user, template, langShortCode, settings);
			}
			return Promise.resolve(false);
		});
	}

	private async sendMailManager(user: Profile, template: string, langShortCode: string, settings: Setting) {
		if (settings.onlyOneMailADay && !await this.hasAlreadyMailToSend(user.email, template, langShortCode)) {
			return this.addMailToSendGroup(user.email, template, langShortCode);
		} else if (!settings.onlyOneMailADay) {
			return this.addMailToSend(user.uuid, user.email, template, langShortCode);
		} else {
			return null;
		}
	}

	private addMailToSendGroup(email: string, template: string, lang: string) {
		return addDoc(collection(this.firestore, `mails/${template}/${lang}`), {
			email: email
		});
	}

	private async hasAlreadyMailToSend(email: string, template: string, lang: string) {
		return (await getCountFromServer(query(collection(this.firestore, `mails/${template}/${lang}`), where('email', '==', email)))).data().count > 0;
	}

	private addMailToSend(userUid: string, email: string, template: string, lang: string) {
		const templates = {
			NewFriend_FR: 6333180,
			NewFriend_EN: 6355422,
			NewMessage_FR: 6355435,
			NewMessage_EN: 6355434
		};
		switch (templates + '_' + lang.toUpperCase()) {
			case 'NewMessageToUser_FR':
				template = templates.NewMessage_FR.valueOf() + '';
				break;
			case 'NewMessageToUser_EN':
				template = templates.NewMessage_EN.valueOf() + '';
				break;
			case 'NewFriendToUser_FR':
				template = templates.NewFriend_FR.valueOf() + '';
				break;
			case 'NewFriendToUser_EN':
				template = templates.NewFriend_EN.valueOf() + '';
				break;
		}
		const sendEmail = httpsCallable(this.functions, 'sendNewMessageTemplate');
		return sendEmail({
			                 destination: email,
			                 template_id: template
		                 });
	}

	private sendMail(to: SendEmailV3_1.EmailAddressTo[], cc: SendEmailV3_1.EmailAddressTo[], bcc: SendEmailV3_1.EmailAddressTo[], subject: string, body: string, id: string): Promise<unknown> {
		const sendEmail = httpsCallable(this.functions, 'sendMail');
		return sendEmail({
			                 to: to,
			                 cc: cc,
			                 bcc: bcc,
			                 subject: subject,
			                 body: body,
			                 id: id
		                 });
	}
}
